// extracted by mini-css-extract-plugin
export var badge = "_hm-2";
export var detailsPanel = "_hm-0";
export var resultRow = "_hm-1";